<template>
  <div class="handoverrec" >
    <el-divider content-position="left">交接记录列表</el-divider>
    <div style="display: flex">
      <el-select
        v-model="searchArr.company_id"
        filterable
        remote
        reserve-keyword
        placeholder="请输入公司名称筛选公司"
        size="mini"
        clearable
        :remote-method="searchRemoteCompanyMethod"
        :loading="searchLoading"
        @change="handleSearchCompanyChange"
      >
        <el-option
          v-for="searchCompany in searchCompanies"
          :key="searchCompany.id"
          :label="searchCompany.company_name"
          :value="searchCompany.id"
        >
        </el-option>
      </el-select>
      <el-popover placement="bottom" width="300" trigger="click" v-model="visible">
        <el-form
          ref="searchform"
          :model="searchform"
          label-width="80px"
          style="padding-right: 0.23rem"
        >
          <el-form-item label="操作时间">
            <el-date-picker
              v-model="searchform.create"
              type="datetimerange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm::ss"
              size="mini"
              :default-time="['00:00:00', '23:59:59']"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="操作人">
            <el-cascader
              style="width: 100%"
              v-model="searchform.own_business"
              placeholder="请选择"
              :options="ownbusinessOptions"
              @click.native="loadOwnbusiness"
              size="mini"
              :props="{ expandTrigger: 'hover' }"
              clearable
              filterable
              :filter-method="filterOptions"
            >
            </el-cascader>
          </el-form-item>
          <div style="text-align: right">
            <el-button type="primary" @click="onSubmit" size="mini"
              >查询</el-button
            >
          </div>
        </el-form>
        <el-button slot="reference" size="mini" style="margin-left: 10px"
          >筛选</el-button
        >
      </el-popover>
    </div>
    <el-drawer
      title="交接记录"
      :visible.sync="handoverRecDrawer"
      :direction="direction"
      :before-close="handleClose"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-timeline style="height: 26rem; overflow: auto">
          <el-timeline-item
            v-for="r in handoverOptions"
            :timestamp="r.created_at"
            placement="top"
            :key="r.id"
          >
            <el-card>
              <h4>
                <span style="color: #409eff">{{ r.company_name }}</span> 的
                <span style="color: #67c23a">{{ r.position }}</span> 交接
              </h4>
              <p style="margin-top: 0.2rem">
                {{ r.ope_name }},在 {{ r.created_at }},将
                {{ r.company_name }} 的 {{ r.position }},由
                {{ r.older !== null ? r.older : "null" }} 设置为
                {{ r.newer !== null ? r.newer : "null" }}
              </p>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </div>
    </el-drawer>
    <el-drawer
      title="公司信息"
      :visible.sync="companyInfoDrawer"
      direction="rtl"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <company-info :companyId="companyComId"></company-info>
        </el-row>
      </div>
    </el-drawer>
    <el-table
      max-height="650"
      :data="tableData"
      style="width: 100%; margin-top: 10px"
      border
      size="mini"
      :header-cell-style="{
        background: '#ecf4ff',
        color: '#333',
        fontWeight: '900',
        fontSize: '0.28rem',
      }"
    >
      <el-table-column
        prop="company_name"
        label="公司名称"
        width="250"
        fixed="left"
      >
        <template slot-scope="scope">
          <el-link
            style="color: #409eff; font-size: 0.28rem; cursor: pointer"
            @click="openCompanyCom(scope.row)"
          >
            {{ scope.row.company_name }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="操作时间">
        <template slot-scope="scope">
          <date-formatter :date-value="scope.row.created_at"></date-formatter>
        </template>
      </el-table-column>
      <el-table-column prop="ope_name" label="操作人"> </el-table-column>
      <el-table-column prop="position" label="交接职位">
        <template slot-scope="scope">
          <span style="color:#67C23A;font-size:0.2rem">{{ scope.row.position }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="older" label="原人员">
        <template slot-scope="scope">
          <span>{{ scope.row.older ? scope.row.older : "空" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="newer" label="现人员">
        <template slot-scope="scope">
          <span>{{ scope.row.newer ? scope.row.newer : "空" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="160" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            content="交接记录"
            placement="top"
          >
            <el-button
              @click.native.prevent="handoverRow(scope.row)"
              type="success"
              size="mini"
              icon="el-icon-notebook-2"
              circle
            >
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div class="block" style="margin-top: 30px; text-align: right">
      <el-pagination
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="sizes, total, prev, pager, next, jumper"
        :total="total"
        :page-sizes="[10, 15, 30, 50, 100]"
        :page-size="perpage"
        background
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import CompanyInfo from 'common/CompanyInfo'
import { filterKeywordOptions } from '../../lib/cascaderUtils.js';
import DateFormatter from 'common/DateFormatter'

export default {
  name: 'HandoverRec',
  components: { CompanyInfo, DateFormatter },
  data () {
    return {
      visible: false,
      companyInfoDrawer: false,
      companyComId: null,
      searchform: {
        own_business: '',
        create: ''
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      searchLoading: false,
      searchCompanies: [],
      searchArr: {
        company_id: '',
        create: []
      },
      tableData: [],
      npage: 1,
      perpage: 10,
      total: null,
      handoverOptions: [],
      handoverRecDrawer: false,
      direction: 'rtl',
      company_id: '',
      ownbusinessOptions: []
    }
  },
  computed: {
    collapse () {
      return this.$store.state.collapse
    }
  },
  methods: {
    loadOwnbusiness () {
      this.$axios.get('/api/customer/getownbusiness').then(res => {
        const { data } = res
        if (data.code === 1) {
          this.ownbusinessOptions = data.data
        }
      })
    },
    filterOptions(node, keyword) {
  return filterKeywordOptions(node, keyword);
},
    searchRemoteCompanyMethod (query) {
      if (query !== '') {
        this.searchLoading = true
        this.searchArrItemCompanys(query)
        setTimeout(() => {
          this.searchLoading = false
        }, 200)
      } else {
        this.searchCompanies = []
      }
    },
    searchArrItemCompanys (query) {
      this.$axios.get('/api/admin/searchCompany?name=' + query).then(res => {
        const { data } = res
        if (data.code === 0) {
          this.searchCompanies = data.data.companies
        }
      })
    },
    handleSearchCompanyChange (val) {
      this.company_id = val
      this.loadTable()
    },
    loadTable () {
      this.$axios
        .get('api/handover/getrec', {
          params: {
            perpage: this.perpage,
            page: this.npage,
            company_id: this.company_id,
            create: this.searchform.create,
            opeer: this.searchform.own_business
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.tableData = data.data.data
            this.total = data.data.total
          }
        })
        .catch()
    },
    onSubmit () {
      console.log(this.searchform.create)
      this.visible = false
      this.loadTable()
    },
    handleCurrentChange (val) {
      this.npage = val
      this.loadTable()
    },
    handleSizeChange (val) {
      this.perpage = val
      this.loadTable()
    },
    handoverRow (row) {
      this.$axios
        .get('api/handover/detrec', {
          params: {
            company_id: row.company_id
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.handoverOptions = data.data
          }
        })
        .catch()
      this.handoverRecDrawer = true
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    openCompanyCom (row) {
      this.companyInfoDrawer = true
      setTimeout(() => {
        this.companyComId = row.company_id
      })
    }
  },
  mounted () {
    this.loadTable()
  }
}
</script>

<style scoped>
.handoverrec {
  /* margin-left: 3.6rem; */
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/handover/HandoverRec.vue